/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    stroke="currentColor"
    stroke-width="1.5"
    d="M2.0833 4c0-1.795 1.4551-3.25 3.25-3.25h13.3334c1.7949 0 3.25 1.455 3.25 3.25v16c0 1.7949-1.4551 3.25-3.25 3.25H5.3333c-1.7949 0-3.25-1.4551-3.25-3.25V4Zm4.5834.9167c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75h10.6666c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75H6.6667Zm0 5.3333c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75h10.6666c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75H6.6667Zm0 5.3333c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75h10.6666c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75H6.6667Z"
  />,
  'MenuListingFilled'
);
